var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLockYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152 74H40C35.5817 74 32 77.5817 32 82V164C32 168.418 35.5817 172 40 172H152C156.418 172 160 168.418 160 164V82C160 77.5817 156.418 74 152 74Z",
    fill: "#FFAD24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 121.75C102.5 118.16 99.5899 115.25 96 115.25C92.4101 115.25 89.5 118.16 89.5 121.75V135C89.5 138.59 92.4101 141.5 96 141.5C99.5899 141.5 102.5 138.59 102.5 135V121.75Z",
    fill: "#CA7300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 126.5C102.075 126.5 107 121.575 107 115.5C107 109.425 102.075 104.5 96 104.5C89.9249 104.5 85 109.425 85 115.5C85 121.575 89.9249 126.5 96 126.5Z",
    fill: "#CA7300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20C77.25 20 62 35.25 62 54V85.09C62 89.96 65.95 93.91 70.82 93.91C75.69 93.91 79.64 89.96 79.64 85.09V54C79.64 44.97 86.98 37.63 96.01 37.63C105.04 37.63 112.38 44.97 112.38 54V85.09C112.38 89.96 116.33 93.91 121.2 93.91C126.07 93.91 130.02 89.96 130.02 85.09V54C130.02 35.25 114.77 20 96.02 20H96Z",
    fill: "#FFAD24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockYellow);
export default __webpack_public_path__ + "static/media/icon_lock_yellow.16c9f0ea.svg";
export { ForwardRef as ReactComponent };